import {
	LabelPosition,
	RHookFormPasswordFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface IEasyWorkForceSetupFieldsPanel {
}
export const EasyWorkForceSetupFieldsPanel: FC<
	IEasyWorkForceSetupFieldsPanel
> = ({ }) => {

	return (
		<>
			<RHookFormTextFieldWithLabel
				label="Company Code"
				id="company_code"
				testId={`company-code`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormTextFieldWithLabel
				label="User Name"
				id="username"
				testId={`user-name`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormPasswordFieldWithLabel
				id="password"
				testId={`password`}
				label="Password"
				labelPosition={LabelPosition.Top}
			// required
			/>
		</>
	);
};
